import { gql } from '@apollo/client';

export const SUBMIT_WORKSPACE_SUBMISSION = gql`
  mutation SubmitWorkspaceFormSubmission($id: ID!) {
    workspaceFormSubmission: submitWorkspaceFormSubmission(id: $id) {
      id
      status
    }
  }
`;
